import { useFacilityCountsQuery } from './useFacilityCountsQuery';
import { useRoleQuery } from './useRoleQuery';
import { useRolesQuery } from './useRolesQuery';
import { useRoleUserCountsQuery } from './useRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface RestoreRolesMutationParams {
  roleIds: string[];
}

export const useCoreRolesRestoreMutation = createMutationHook(
  'settings.teamPermissions.restoreRoles',
  (params: RestoreRolesMutationParams) => ({
    coreRolesRestore: {
      __args: {
        input: {
          roleIds: params.roleIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [
      useRolesQuery,
      useRoleUserCountsQuery,
      useRoleQuery,
      useFacilityCountsQuery,
    ],
  },
);
